export const ObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'The Dinomension',
    headline: '關於我',
    description: 'The Dinomension NFTs are  10,000 algorithmically-generate art pieces based on ERC-721. Every  NFT is unique and  its traits are all hand-drawn. Each NFT  qualify you as a citizen  of The Dinomension. You will have an access to the citizen-only area  and attend events exclusively for the citizens. The Dinomention is a collection of 10,000 ERC-721 NFTs. Each NFT is uique and randomly generated from total 170 hand-drwan traits. <br />The NFT also qualify us as a citizen  of The Dinomension. You will have an access to the citizen-only area  and attend events exclusively for the citizens.<br />包含連載漫畫以及互動遊戲打造nft世界中全新的沉浸式體驗，嶄新的世界觀，體驗真正成為一隻龍，建立互動性極高的公民龍社群，公民可以討論劇情，甚至投票改變劇情發展及project的未來。',
    buttonLabel: '聯絡我',
    imgStart: true,
    alt: 'Coding',
    dark: true,
    primary: true,
    darkText: false
}
